

import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import { type RootState } from '../store';

export type CategoryRedux = { 
    sellId:number | null, 
    sellImg:string,
    sellSlug:string,
    sellTitle:string,
    sellImgAlt:string
}

const initialState:CategoryRedux= {
sellId:null,
sellImg:'',
sellSlug:'',
sellTitle:'Loading',
sellImgAlt:''

}

const productCategorySlice = createSlice({
    name:'product_category',
    initialState,
    reducers:{
        setProductCategory:(state, action:PayloadAction<CategoryRedux>) =>{
            state = action.payload

         
        }
    }
})

export const selectProductCategory = (rootState:RootState) => rootState.productCategeory

export const {setProductCategory} = productCategorySlice.actions;
export default productCategorySlice.reducer